var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('b-container',{staticClass:"mt-5 mb-3"},[_c('PasswordSetForm',{attrs:{"uid":_vm.uid,"token":_vm.token}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }